import React, { useContext } from 'react';
import { IModifierGroupContext, ModifierGroupContext } from '../../../modifierGroupState/modifierGroupContext';
import SearchField from 'components/SearchField/SearchField';

export const Search: React.FC = () => {
	const { changeSearchString, searchString, modifierGroups } =
		useContext<IModifierGroupContext>(ModifierGroupContext);

	return (
		<SearchField
			onChangeSelectSearchString={changeSearchString}
			searchString={searchString}
			delay={modifierGroups.modifierGroupsCount ? 800 : undefined}
		/>
	);
};
